import { Link, NavLink } from 'react-router-dom'
import './index.scss'
import LogoH from '../../assets/images/logo-h.png'
import LogoSubtitle from '../../assets/images/sub.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faHome, faUser } from '@fortawesome/free-solid-svg-icons'
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons'

 const Sidebar = () => (
    <div className='nav-bar'>
        <Link className='logo' to="/">
            <img src={LogoH} alt="logo" />
            <img className='sub-logo' src={LogoSubtitle} alt="slobodan" />
        </Link>
        <nav>
            <NavLink exact="true" activeclassname="active" to="/">
                <FontAwesomeIcon icon={faHome} color="#4d4d4e" />
            </NavLink>

            <NavLink exact="true" activeclassname="active" className="about-link" to="/about">
                <FontAwesomeIcon icon={faUser} color="#4d4d4e" />
            </NavLink>

            <NavLink exact="true" activeclassname="active" className="contact-link" to="/contact">
                <FontAwesomeIcon icon={faEnvelope} color="#4d4d4e" />
            </NavLink>
        </nav>
        <ul>

            <li>
                <a target='_blank' rel="noreferrer" href='https://www.linkedin.com/in/yves-velasquez-06122a242/'>
                    <FontAwesomeIcon icon={faLinkedin} color="#daddd8" />
                </a>
            </li>
        
        
            <li>
                <a target='_blank' rel="noreferrer" href='https://github.com/HallowsYves'>
                    <FontAwesomeIcon icon={faGithub} color="#daddd8" />
                </a>
            </li>
        
        
        </ul>
    </div>
)

 
 export default Sidebar